'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VXFiltersCurrent = undefined;

var _isEmpty = require('ramda/src/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _map = require('ramda/src/map');

var _map2 = _interopRequireDefault(_map);

var _values = require('ramda/src/values');

var _values2 = _interopRequireDefault(_values);

var _pipe = require('ramda/src/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _core = require('@blueprintjs/core');

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _withFiltersCurrent = require('./with-filters-current');

var _ = require('../../');

var _vxFilterContainer = require('../vx-filter-container');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilterCurrentWrapper = _glamorous2.default.div({
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'row'
});

var StyledFilterTag = (0, _glamorous2.default)(_core.Tag, { filterProps: ['isRtl'] })({
  marginRight: 5,
  marginBottom: 5
}, function (_ref) {
  var isRtl = _ref.isRtl;
  return {
    '.pt-tag-removable': {
      paddingRight: isRtl ? '6px' : null,
      paddingLeft: isRtl ? 0 : '6px'
    },
    '.pt-tag.pt-tag-removable > .pt-tag-remove': {
      position: isRtl ? 'initial' : 'absolute'
    } };
});

var ClearAllWrapper = _glamorous2.default.div({
  paddingTop: 5,
  borderTop: '1px dashed ' + _.Colors.GREY2
});

var FilterCurrent = function FilterCurrent(_ref2) {
  var id = _ref2.id,
      label = _ref2.label,
      values = _ref2.values,
      onClearFilter = _ref2.onClearFilter,
      onClearFilterValue = _ref2.onClearFilterValue,
      isRtl = _ref2.isRtl;
  return _react2.default.createElement(
    FilterCurrentWrapper,
    null,
    _react2.default.createElement(
      StyledFilterTag,
      {
        className: (0, _classnames2.default)(_core.Classes.MINIMAL),
        intent: _core.Intent.PRIMARY,
        onRemove: onClearFilter(id),
        isRtl: isRtl
      },
      label
    ),
    (0, _pipe2.default)(_values2.default, (0, _map2.default)(function (value) {
      return _react2.default.createElement(
        StyledFilterTag,
        {
          key: value.id,
          className: (0, _classnames2.default)(_core.Classes.MINIMAL),
          onRemove: onClearFilterValue(id, value.id),
          isRtl: isRtl
        },
        value.label
      );
    }))(values)
  );
};

FilterCurrent.propTypes = {
  id: _propTypes2.default.string.isRequired,
  label: _propTypes2.default.string,
  values: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string
  })),
  onClearFilter: _propTypes2.default.func.isRequired,
  onClearFilterValue: _propTypes2.default.func.isRequired,
  isRtl: _propTypes2.default.bool
};

var VXFilterContainer = (0, _vxFilterContainer.VXFilterContainerHOC)();

var FiltersCurrent = function FiltersCurrent(_ref3) {
  var titleLabel = _ref3.titleLabel,
      statusLabel = _ref3.statusLabel,
      clearAllLabel = _ref3.clearAllLabel,
      items = _ref3.items,
      onClearAll = _ref3.onClearAll,
      onClearFilter = _ref3.onClearFilter,
      onClearFilterValue = _ref3.onClearFilterValue,
      isOpen = _ref3.isOpen,
      isRtl = _ref3.isRtl,
      noScroll = _ref3.noScroll;
  return _react2.default.createElement(
    VXFilterContainer,
    {
      titleLabel: titleLabel,
      statusLabel: statusLabel,
      isOpen: isOpen,
      isBlank: (0, _isEmpty2.default)(items),
      isRtl: isRtl,
      noScroll: true
    },
    (0, _pipe2.default)(_values2.default, (0, _map2.default)(function (filter) {
      return _react2.default.createElement(FilterCurrent, _extends({
        key: filter.id
      }, filter, {
        onClearFilter: onClearFilter,
        onClearFilterValue: onClearFilterValue,
        isRtl: isRtl
      }));
    }))(items),
    _react2.default.createElement(
      ClearAllWrapper,
      null,
      _react2.default.createElement(
        StyledFilterTag,
        { className: (0, _classnames2.default)(_core.Classes.MINIMAL), onRemove: onClearAll, isRtl: isRtl },
        clearAllLabel
      )
    )
  );
};

FiltersCurrent.propTypes = {
  titleLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  statusLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  clearAllLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  items: _propTypes2.default.objectOf(_propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired
  })),
  onClearAll: _propTypes2.default.func.isRequired,
  onClearFilter: _propTypes2.default.func.isRequired,
  onClearFilterValue: _propTypes2.default.func.isRequired,
  isOpen: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  noScroll: _propTypes2.default.bool
};

FiltersCurrent.defaultProps = {
  items: {}
};

var VXFiltersCurrent = exports.VXFiltersCurrent = (0, _withFiltersCurrent.withFiltersCurrent)(FiltersCurrent);


//////////////////
// WEBPACK FOOTER
// ./~/oecd-visions/build/components/vx-filters-current/index.js
// module id = 2032
// module chunks = 0